/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'bot-detection-policy';
const componentName = 'bot-detection-result-match-grid';
const prefix = `${moduleName}.${componentName}`;

export const classificationsLabelWithCount = `${prefix}.classificationLabelWithCount`;
export const addButtonLabel = `${prefix}.addButtonLabel`;
export const classificationLabel = `${prefix}.classificationLabel`;
export const classificationPlaceHolder = `${prefix}.classificationPlaceHolder`;

export const ENGLISH = {
    [addButtonLabel]: 'Add',
    [classificationsLabelWithCount]: 'Classifications ({0})',
    [classificationLabel]: 'Classification',
    [classificationPlaceHolder]: 'Select Classification',
};
